import { useEffect, useRef } from "react"
// import flvjs from "flv.js"
import JMuxer from "jmuxer"

const BenuvemPlayer = ({ url, style, cameraPrincipal, snapshot }) => {
    console.log(url)

    const videoRef = useRef(null)
    // const playerRef = useRef(null)

    // useEffect(() => {
    //     if (cameraPrincipal && flvjs.isSupported() && videoRef.current) {
    //         if (playerRef.current) {
    //             playerRef.current.destroy()
    //         }

    //         const flvPlayer = flvjs.createPlayer({ type: "flv", url })
    //         playerRef.current = flvPlayer

    //         flvPlayer.attachMediaElement(videoRef.current)

    //         flvPlayer.on("error", (err) => {
    //             console.error("Erro no FLV Player:", err)
    //         })

    //         try {
    //             flvPlayer.load()
    //         } catch (err) {
    //             console.error("Erro ao carregar o vídeo:", err)
    //         }

    //         flvPlayer.play()

    //         return () => {
    //             if (playerRef.current) {
    //                 playerRef.current.destroy()
    //                 playerRef.current = null
    //             }
    //         }
    //     }
    // }, [url, cameraPrincipal])

    useEffect(() => {
        if (cameraPrincipal) {
            let jmuxer = new JMuxer({
                node: videoRef.current,
                mode: 'video',
                flushingTime: 300,
                readFpsFromTrack: true,
                fps: 15,
                debug: true,
                clearBuffer: true
            })

            let ws = new WebSocket(url)
            ws.binaryType = 'arraybuffer'

            ws.onopen = () => {
                console.log('WebSocket benuvem conectado')
            }

            ws.onmessage = (event) => {
                console.log('onmessage')

                if (event.data instanceof ArrayBuffer && event.data.byteLength > 0) {
                    jmuxer.feed({
                        video: new Uint8Array(event.data)
                    })
                }
            }

            ws.onclose = () => {
                console.log('WebSocket benuvem desconectado')
            }

            ws.onerror = (error) => {
                console.error('Erro no WebSocket benuvem:', error)
            }

            return () => {
                if (jmuxer) {
                    jmuxer.destroy()
                }

                if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
                    ws.close()
                }
            }
        }
    }, [url, cameraPrincipal])

    if (!cameraPrincipal) {
        return <img src={snapshot} alt="Snapshot da câmera" style={style} />
    }

    return <video style={style} ref={videoRef} autoPlay muted />
}

export default BenuvemPlayer
